import { render } from "./ArtistListItem.vue?vue&type=template&id=609f814e&scoped=true"
import script from "./ArtistListItem.vue?vue&type=script&lang=js"
export * from "./ArtistListItem.vue?vue&type=script&lang=js"

import "./ArtistListItem.vue?vue&type=style&index=0&id=609f814e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609f814e"]])

export default __exports__